import React from "react"

const ConferenceContex = React.createContext({})

export default ConferenceContex
